import { render, staticRenderFns } from "./ExtraProtection.vue?vue&type=template&id=8e2a3658&"
import script from "./ExtraProtection.vue?vue&type=script&lang=js&"
export * from "./ExtraProtection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports